import { CarregarPermissoes, ValidarPermissao } from '@/modules/system/auth/application/auth.service';
import { NavigationView } from '@/shared/constants/navigation-view.enum';
import { PermissionEnum } from '@/modules/system/auth/domain/enums/permission.enum';
import { RoleEnum } from '@/modules/system/auth/domain/enums/role.enum';

function ehEstagiarioPorPermissao(): boolean {
  const permissoes = CarregarPermissoes();
  // Gestão de folhas / cadastros (ex.: Subcorregedoria) — não é estagiário operacional.
  if (
    ValidarPermissao(permissoes, [
      { role: RoleEnum.FOLHA_SEND_NOTIFICATION, level: PermissionEnum.READ },
    ]) ||
    ValidarPermissao(permissoes, [{ role: RoleEnum.PESSOA, level: PermissionEnum.READ }])
  ) {
    return false;
  }
  return (
    ValidarPermissao(permissoes, [{ role: RoleEnum.ESTAGIARIO, level: PermissionEnum.READ }]) &&
    ValidarPermissao(permissoes, [{ role: RoleEnum.FOLHA, level: PermissionEnum.UPDATE }]) &&
    !ValidarPermissao(permissoes, [{ role: RoleEnum.MOVIMENTACAO, level: PermissionEnum.READ }])
  );
}

const VISOES_NAO_ESTAGIARIO = new Set<NavigationView>([
  NavigationView.Administrador,
  NavigationView.Corregedoria,
  NavigationView.Subcorregedoria,
  NavigationView.DefensorDiretor,
  NavigationView.Defensor,
  NavigationView.Colaborador,
  NavigationView.RecursosHumanos,
  NavigationView.Auxiliar,
  NavigationView.GestorRelatorios,
]);

/** Estagiário não acessa a listagem mensal de folhas (`/folhas`). */
export function ehPerfilEstagiario(
  authVisao: NavigationView | null,
  effectiveView: NavigationView | null,
): boolean {
  if (authVisao != null && VISOES_NAO_ESTAGIARIO.has(authVisao)) {
    return false;
  }
  if (effectiveView != null && VISOES_NAO_ESTAGIARIO.has(effectiveView)) {
    return false;
  }
  if (
    authVisao === NavigationView.Estagiario ||
    effectiveView === NavigationView.Estagiario
  ) {
    return true;
  }
  return ehEstagiarioPorPermissao();
}

function ehDefensorPorPermissao(): boolean {
  const permissoes = CarregarPermissoes();
  return (
    ValidarPermissao(permissoes, [{ role: RoleEnum.DEFENSOR, level: PermissionEnum.READ }]) &&
    ValidarPermissao(permissoes, [{ role: RoleEnum.MOVIMENTACAO, level: PermissionEnum.READ }]) &&
    !ValidarPermissao(permissoes, [{ role: RoleEnum.PESSOA, level: PermissionEnum.READ }])
  );
}

/** Defensor e defensor diretor não enviam notificações em massa nas folhas por mês. */
export function ehPerfilDefensor(
  authVisao: NavigationView | null,
  effectiveView: NavigationView | null,
): boolean {
  if (
    authVisao === NavigationView.GestorRelatorios ||
    effectiveView === NavigationView.GestorRelatorios
  ) {
    return false;
  }
  if (
    authVisao === NavigationView.Defensor ||
    authVisao === NavigationView.DefensorDiretor ||
    effectiveView === NavigationView.Defensor ||
    effectiveView === NavigationView.DefensorDiretor
  ) {
    return true;
  }
  return ehDefensorPorPermissao();
}

function ehColaboradorPorPermissao(): boolean {
  const permissoes = CarregarPermissoes();
  return (
    ValidarPermissao(permissoes, [{ role: RoleEnum.COLABORADOR, level: PermissionEnum.READ }]) &&
    ValidarPermissao(permissoes, [{ role: RoleEnum.FOLHA, level: PermissionEnum.READ }]) &&
    !ValidarPermissao(permissoes, [{ role: RoleEnum.FOLHA, level: PermissionEnum.UPDATE }]) &&
    !ValidarPermissao(permissoes, [{ role: RoleEnum.PESSOA, level: PermissionEnum.READ }]) &&
    !ValidarPermissao(permissoes, [{ role: RoleEnum.MOVIMENTACAO, level: PermissionEnum.READ }])
  );
}

/** Colaborador só pode escolher a si próprio como responsável no filtro. */
export function ehPerfilColaborador(
  authVisao: NavigationView | null,
  effectiveView: NavigationView | null,
): boolean {
  if (
    authVisao === NavigationView.Colaborador ||
    effectiveView === NavigationView.Colaborador
  ) {
    return true;
  }
  return ehColaboradorPorPermissao();
}

export function filtrarResponsaveisParaPessoa(
  responsaveis: { label: string; value: string | number }[],
  pessoaId?: string,
): { label: string; value: string | number }[] {
  if (!pessoaId) return responsaveis;
  return responsaveis.filter(
    (item) => Number(item.value) === 0 || String(item.value) === pessoaId,
  );
}

/** Notificações em massa: perfis de gestão (corregedoria, RH, etc.), não defensor/estagiário. */
export function podeExibirNotificacoesFolhasEmMassa(
  authVisao: NavigationView | null,
  effectiveView: NavigationView | null,
): boolean {
  return !ehPerfilEstagiario(authVisao, effectiveView) &&
    !ehPerfilDefensor(authVisao, effectiveView);
}

/**
 * Perfis que supervisionam folhas mas não devem escolher outro responsável no filtro.
 * Colaborador mantém o seletor visível, porém a API retorna apenas a própria pessoa.
 */
export function podeExibirFiltroResponsavel(
  authVisao: NavigationView | null,
  effectiveView: NavigationView | null,
): boolean {
  return (
    !ehPerfilEstagiario(authVisao, effectiveView) &&
    !ehPerfilDefensor(authVisao, effectiveView)
  );
}
